// React
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

//External Packages

// Internal Components
import Register from "./components/Register";
import TestFooter from "../../components/layouts/Footer/TestFooter";
import Header from "../../components/layouts/Header/Header";

// User Actions

// Images

// Styling
import "./registerscreen.css";
import CommonsModal from "./components/CommonsModal";
import SEO from "../../components/seo/SEO";

export default function ViewRegisterScreen() {
  const pageContent = () => {
    if (window && window.location.pathname === "/register") {
      return (
        <>
          <Register />
        </>
      );
    } else {
      return <CommonsModal />;
    }
  };
  return (
    <>
      <SEO
        title="Register"
        description="Register for a NoWastedDays journal to boost your self-awareness and self-assurance."
        canonicalUrl={"https://nowasteddays.io/register"}
      />
      <Header variant="light" />

      <section id="registerScreen">{pageContent()}</section>

      <TestFooter />
    </>
  );
}
